var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.img)?_c('ul',{staticClass:"float"},_vm._l((8),function(i){return _c('li',{key:i,staticClass:"item",style:({'animation-duration':_vm.duration(i)})},[_c('img',{attrs:{"src":_vm.img,"alt":""}})])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }